/**
 * Use the ImageCropperDialog component instead of the Dialog component when you need to display a dialog with an image cropper.
 * There is a bug in the library which adds some margin because of the scale and slide in animations of the Dialog component.
 * This component disables those animation when opening, it still adds an animation on the opacity.
 *
 * See https://www.npmjs.com/package/react-easy-crop#known-issues for more information.
 */

import {
  Dialog as HeadlessDialog,
  DialogBackdrop as HeadlessDialogBackdrop,
  DialogPanel as HeadlessDialogPanel,
} from "@headlessui/react";
import type { DialogProps } from "../Dialog";
import { dialogVariants } from "../Dialog/variants";

export function ImageCropperDialog({
  open,
  onClose,
  size = "lg",
  className,
  children,
  ...props
}: DialogProps) {
  return (
    <HeadlessDialog onClose={onClose} open={open} {...props}>
      <HeadlessDialogBackdrop
        transition
        className="fixed inset-0 z-20 bg-zinc-950/25 dark:bg-zinc-950/50 duration-100 ease-out data-[closed]:opacity-0"
      />

      <div className="fixed inset-0 z-20 grid grid-rows-[1fr_auto] justify-items-center sm:grid-rows-[1fr_auto_3fr] sm:p-4">
        <HeadlessDialogPanel
          className={dialogVariants({ className, size })}
          transition
        >
          {children}
        </HeadlessDialogPanel>
      </div>
    </HeadlessDialog>
  );
}
